import _ from 'lodash';
import Dotdotdot from 'react-dotdotdot';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';
import { default as ConversationModel } from 'models/conversation';
import NavigateToConversation from 'actions/conversation/navigate_to_conversation';
import ShortLongDate from 'components/lib/date/short_long_date';

export function Conversation({ conversation, customerId, onClickConversation, topicNames }) {
  return (
    <div className="conversationNav-conversation" onClick={onClickConversation}>
      <div className="conversationNav-conversation-icon">
        <FontAwesomeIcon icon={faCalendarAlt} />
      </div>
      <div className="conversationNav-conversation-timestamp">
        <ShortLongDate timestamp={conversation.createdAt} />
      </div>
      <div className="conversationNav-conversation-label">
        <Dotdotdot clamp={3}>{getLabel()}</Dotdotdot>
      </div>
    </div>
  );

  function getLabel() {
    if (!topicNames.length) {
      return _.upperFirst(conversation.status.toLowerCase());
    }
    return topicNames.join(', ');
  }
}

Conversation.propTypes = {
  conversation: PropTypes.instanceOf(ConversationModel),
  customerId: PropTypes.string.isRequired,
  onClickConversation: PropTypes.func.isRequired,
  topicNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const ConversationContainer = connect(mapStateToProps, mapExecuteToProps)(Conversation);

ConversationContainer.propTypes = {
  conversation: PropTypes.instanceOf(ConversationModel).isRequired,
  customerId: PropTypes.string.isRequired,
};

export default ConversationContainer;

function mapStateToProps({ getProvider }, { conversation, customerId }) {
  const topicNames =
    (conversation &&
      _(conversation.topicIds)
        .map(id => {
          let t = getProvider('topics').findBy({ id });
          return t ? t.name : null;
        })
        .compact()
        .value()) ||
    [];

  return {
    conversation,
    customerId,
    topicNames,
  };
}

function mapExecuteToProps(executeAction, { customerId, conversation }) {
  return {
    onClickConversation: () => executeAction(NavigateToConversation, { customerId, conversationId: conversation.id }),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/conversation.jsx